import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { GetLicenceRenewals, GetLicenceRenewalsVariables } from "./__generated__/GetLicenceRenewals";

export const GET_LICENCE_RENEWALS = gql`
  query GetLicenceRenewals($skip: Int, $take: Int, $orgId: String) {
    licenceRenewals(skip: $skip, take: $take, orgId: $orgId) {
      totalCount
      items {
        id
        productName
        type
        startDate
        endDate
        numberOfUsers
        totalPrice
        dateCreated
        organization {
          id
          name
        }
      }
    }
  }
`;

export function useLazyGetLicenceRenewals() {
  const [getLicenceRenewals, { loading, error, data }] = useLazyQuery<GetLicenceRenewals, GetLicenceRenewalsVariables>(
    GET_LICENCE_RENEWALS,
    {
      fetchPolicy: "cache-and-network",
      errorPolicy: "all",
    }
  );

  return {
    getLicenceRenewals,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
